import { render, staticRenderFns } from "./SiestaShare.vue?vue&type=template&id=1a126214&scoped=true&"
import script from "./SiestaShare.vue?vue&type=script&lang=js&"
export * from "./SiestaShare.vue?vue&type=script&lang=js&"
import style0 from "./SiestaShare.vue?vue&type=style&index=0&id=1a126214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a126214",
  null
  
)

export default component.exports